import { isLocalStorageAvailable, onServer, uuid } from "utils/utils";

export const deviceId = (): string => {
  if (onServer) {
    return "";
  }

  if (isLocalStorageAvailable() && localStorage.getItem("deviceId")) {
    return localStorage.getItem("deviceId") as string;
  }
  const deviceId = uuid();

  if (isLocalStorageAvailable()) {
    localStorage.setItem("deviceId", deviceId);
  }

  return deviceId;
};
